import History from 'Store/history';
import {
  URL_MAP_BY_TYPE,
  SPORT_TYPE_BY_URL,
  BULLETIN_TYPES,
  ALL_EVENTS,
  FOOTBALL
} from 'Store/constants/sportTypes';


const pathnameParser = pathname => {
  const bulletinName = pathname.split('/')[1];
  const sportType = pathname.split('/')[2] || URL_MAP_BY_TYPE[pathname === '/canli-iddaa' ? ALL_EVENTS : FOOTBALL];

  const isLongTermUrl = sportType?.startsWith('uzun-vadeli');

  let bulletinType;
  switch (bulletinName) {
    case 'iddaa':
      bulletinType = BULLETIN_TYPES.PREMATCH;
      break;

    case 'canli-iddaa':
      bulletinType = BULLETIN_TYPES.LIVE;
      break;
  }

  const isValidUrl = !!(bulletinType && SPORT_TYPE_BY_URL[sportType]);

  return {
    isLongTermUrl,
    bulletinType,
    sportType: SPORT_TYPE_BY_URL[sportType],
    isValidUrl
  };
};

const navigate = (bulletinType, sportType) => {
  let url;

  switch (bulletinType) {
    case BULLETIN_TYPES.LIVE: {
      +sportType === ALL_EVENTS ? url = '/canli-iddaa' : url = `/canli-iddaa/${URL_MAP_BY_TYPE[sportType]}`;
      break;
    }

    case BULLETIN_TYPES.PREMATCH: {
      if (sportType === FOOTBALL) {
        url = '/iddaa';
      } else {
        url = `/iddaa/${URL_MAP_BY_TYPE[sportType]}`;
      }
      break;
    }
  }

  if (url) {
    History.push(url);
  }
};

const getRequestTypes = pathname => {

  const { sportType, bulletinType } = pathnameParser(pathname);

  return {
    sportType,
    bulletinType
  };
};

const getIsValidUrl = pathname => {
  const { isValidUrl } = pathnameParser(pathname);

  return isValidUrl;
};

const getHashName = pathname => {
  const { sportType, bulletinType } = pathnameParser(pathname);

  return bulletinType + ':' + sportType;
};

const getCapitalizeText = text => {
  if (typeof text !== 'string') return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export default {
  navigate,
  getRequestTypes,
  isValidUrl: getIsValidUrl,
  getHashName,
  capitalize: getCapitalizeText,
};
